import styled from 'styled-components';
import Form from 'components/form';
import { Row } from 'components/layout';
import BackIcon from 'styles/icons/back.svg';
import { typography, color } from 'styles/settings';
import { normalize, withModifiers } from 'utils/styles';

export const NameTextInput = styled(Form.TextInput).attrs({
  style: {
    margin: 0,
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
})`
  & {
    margin: 2px 0 0 0;
    color: ${color.neutral.gray};
    font-size: ${normalize('24px')};
    ${typography.font.semiBold};
    height: ${normalize('28px')};
    line-height: ${normalize('28px')};
    padding-left: 0;
    width: 100%;

    text-align: center;

    @media all and (max-width: 1200px) {
      text-align: left;
    }

    & + div {
      position: absolute;
      margin-top: ${normalize('50px')};
    }
  }
`;

export const BackButton = styled.a`
  align-self: center;
  ${typography.font.content.semiBold};
  font-size: ${typography.size.sm};
  cursor: pointer;
  background-image: url('${BackIcon}');
  background-repeat: no-repeat;
  background-position: center left;
  background-size: 1em;
  padding-left: 1.5em;
  display: block;
  min-width: 200px;
  height: 28px;
  line-height: 28px;

  @media all and (max-width: 1200px) {
    display: none;
  }
`;

export const HeaderControls = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: flex-end;
`;

export const Header = styled(Row)`
  padding: 15px 20px;
  height: 45px;
`;

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${color.neutral.white};
`;

const Content = styled.div`
  position: relative;
  margin: ${normalize('32px')} ${normalize('40px')} ${normalize('0px')}
    ${normalize('40px')};
  height: calc(100% - 120px);
  ${withModifiers('isImage')`
    display:flex;
  `}
  #cortlex-pspdf {
    height: 100% !important;
  }
`;

const Fullscreen = {
  Controls: HeaderControls,
  Header,
  Wrapper,
  Content,
};

export const RegularContainer = styled.div``;

export default Fullscreen;
